import { render, staticRenderFns } from "./success.vue?vue&type=template&id=4f4e072a"
var script = {}
import style0 from "./success.vue?vue&type=style&index=0&id=4f4e072a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports